// Helpers for round-tripping a JavaScript Date through a
// `<input type="datetime-local">`. The native input speaks local time
// (no zone suffix) — using `Date.prototype.toISOString().slice(0,16)`
// silently shifts the value by the user's UTC offset, so we format and
// parse explicitly here.

const pad2 = (value: number): string => String(value).padStart(2, '0');

export function formatLocalDateTimeInput(date: Date): string {
  return (
    [date.getFullYear(), pad2(date.getMonth() + 1), pad2(date.getDate())].join(
      '-'
    ) + `T${pad2(date.getHours())}:${pad2(date.getMinutes())}`
  );
}

export function localDateTimeInputToISOString(value: string): string {
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (!match) {
    throw new Error(`invalid datetime-local value: ${value}`);
  }
  const [, year, month, day, hour, minute] = match;
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute)
  ).toISOString();
}
